import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';
import {BusinessFleetService} from 'services/calculator-items/business-fleet.service';

@Component({
  selector: 'tpc-fleet-car',
  templateUrl: './fleet-car.component.html',
  styleUrls: ['./fleet-car.component.css']
})
export class FleetCarComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private countDefaultValue = 1;

    private _fuelTypes = {
        gasoline: 'Gasoline',
        diesel: 'Diesel',
        bioDieselB20: 'Biodiesel (B20)',
        bioDieselB100: 'Biodiesel (B100)',
        cng: 'Compressed Natural Gas',
        e85ethanol: 'E85 Ethanol'
    };

    private fuelTypeDisplayNames = {
        gasoline: 'Gasoline',
        diesel: 'Diesel',
        bioDieselB20: 'Biodiesel B20',
        bioDieselB100: 'Biodiesel B100',
        cng: 'CNG',
        e85ethanol: 'Ethanol'
    };

    private _carTypes = {
        car: 'Car',
        semi: 'Semi Truck',
        truck: 'Pickup Truck',
        deliveryTruck: 'Delivery Truck'
    };

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private fleetService: BusinessFleetService,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    get fuelTypes(): Object {
        return this._fuelTypes;
    }

    private createForm() {
        this._form = this.fb.group({
            count: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            fuelType: ['', [Validators.required]],
            mile: ['', [Validators.required]]
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'fleet';
        let params = {
            count: this.getFV('count'),
            fuelType: this.getFV('fuelType'),
            mile: this.getFV('mile'),
            vehicleType: this.router.url.split('/')[3]
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.fleetService.addToVehicleList({
                    title: this.getTitleForVehicleList(params),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.spinner.hide();
                this.router.navigate(['/business/fleet/list']);
            }
        );
    }

    private getTitleForVehicleList(params) {
        let carType = this._carTypes[this.router.url.split('/')[3]];
        return `${params.count + ' ' + carType + (params.count === '1' ? '' : 's')}, ${this.fuelTypeDisplayNames[params.fuelType]}, ${params.mile} mi/yr`;
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-car/fleet-car.component.ts